import DashboardLayout from "../components/DashboardLayout";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { 
  BookOpen, 
  Users, 
  Trophy, 
  Upload, 
  Download, 
  Mail, 
  FileSpreadsheet,
  Globe,
  Calculator,
  HelpCircle,
  Shield,
  UserCheck,
  Image,
  Award,
  KeyRound
} from "lucide-react";

export default function Manual() {
  const sections = [
    {
      icon: Shield,
      title: "Roles de Usuario",
      content: [
        "ADMINISTRADOR: Primer usuario registrado. Gestiona toda la plataforma.",
        "DELEGADO: Debe ser aprobado por el administrador para acceder.",
        "El administrador aprueba registros desde el panel de Administración.",
        "Solo el administrador puede acceder a la base de datos completa de pilotos.",
        "Los delegados pueden usar la app pero NO ven el listado completo de pilotos."
      ]
    },
    {
      icon: KeyRound,
      title: "Recuperación de Contraseña",
      content: [
        "Desde la página de inicio, haz clic en '¿Olvidaste tu contraseña?'",
        "Introduce tu email de registro.",
        "Recibirás un enlace de recuperación (válido 2 horas).",
        "El enlace te llevará a una página para crear nueva contraseña.",
        "También puedes cambiar tu contraseña desde el menú de usuario (arriba derecha)."
      ]
    },
    {
      icon: Users,
      title: "Base de Datos de Pilotos",
      content: [
        "La base de datos de pilotos es GLOBAL para toda la aplicación.",
        "Solo el ADMINISTRADOR puede ver, subir y modificar los pilotos.",
        "Los delegados NO tienen acceso al listado de pilotos (protección de datos).",
        "El admin sube la base desde: Administración → Base de Pilotos.",
        "Formato del archivo: Excel con columnas licencia, nombre, apellidos, email, categoria."
      ]
    },
    {
      icon: Trophy,
      title: "Crear un Campeonato",
      content: [
        "Ve a 'Campeonatos' y haz clic en 'Nuevo Campeonato'.",
        "Configura el nombre, descripción y si es público o privado.",
        "Define el número total de pruebas (1-10).",
        "Define cuántas pruebas cuentan para la clasificación final.",
        "Activa 'Puntos por Asistencia' si quieres bonificar participación.",
        "Si activas asistencia, selecciona el modelo de puntos a usar."
      ]
    },
    {
      icon: Award,
      title: "Modelos de Asistencia (Admin)",
      content: [
        "Accede desde Administración → Modelos Asistencia.",
        "Paso 1: Selecciona el número de pruebas del campeonato (3, 4, 5, 6...).",
        "Paso 2: Escribe un nombre descriptivo (ej: 'AECAR 5 Pruebas').",
        "Paso 3: Asigna los puntos para cada número de pruebas disputadas.",
        "Ejemplo 4 pruebas: 4=150pts, 3=100pts, 2=50pts, 1=0pts.",
        "Puedes crear tantos modelos como necesites para diferentes campeonatos."
      ]
    },
    {
      icon: Users,
      title: "Usar Modelos de Asistencia",
      content: [
        "Al crear un campeonato, activa 'Puntos por Asistencia'.",
        "Selecciona el modelo apropiado para tu número de pruebas.",
        "Los puntos se sumarán automáticamente según las carreras disputadas.",
        "Los campeonatos antiguos usan el modelo AECAR estándar por defecto.",
        "Puedes cambiar el modelo editando el campeonato."
      ]
    },
    {
      icon: Upload,
      title: "Subir Resultados de Carrera",
      content: [
        "Abre el detalle del campeonato haciendo clic en él.",
        "Descarga la plantilla Excel de resultados.",
        "Rellena la plantilla con: licencia (columna A) y posición (columna B).",
        "Selecciona la carrera (C1, C2, C3...) y sube el archivo Excel.",
        "Los resultados se procesarán automáticamente y actualizarán la clasificación."
      ]
    },
    {
      icon: Calculator,
      title: "Sistema de Puntos AECAR",
      content: [
        "Escala oficial: 1º=640, 2º=613, 3º=587... hasta 90º=2 puntos.",
        "Posiciones 91 en adelante reciben 1 punto.",
        "Cada celda muestra: puntos (posición) - Ej: '640 (1º)', '613 (2º)'.",
        "El descarte elimina automáticamente los peores resultados (aparecen tachados).",
        "Desempate según Art. 18.1 AECAR: victorias > segundos > terceros > descarte."
      ]
    },
    {
      icon: Globe,
      title: "Clasificación Pública",
      content: [
        "Activa 'Clasificación Pública' al crear o editar el campeonato.",
        "Se generará un enlace único que puedes compartir.",
        "Cualquiera con el enlace puede ver la clasificación actualizada.",
        "La clasificación muestra puntos y posición por carrera.",
        "La clasificación privada solo es visible para ti."
      ]
    },
    {
      icon: Download,
      title: "Exportar Clasificación",
      content: [
        "Desde el detalle del campeonato, haz clic en 'Descargar PDF'.",
        "Se generará un archivo HTML con el diseño oficial AECAR.",
        "Incluye el logo, colores corporativos y formato profesional.",
        "Muestra puntos y posición de cada carrera.",
        "Perfecto para imprimir o compartir por email."
      ]
    },
    {
      icon: Mail,
      title: "Enviar por Email",
      content: [
        "Haz clic en 'Enviar por Email' en el detalle del campeonato.",
        "Escribe el asunto y mensaje personalizado.",
        "Se enviará a todos los pilotos que tengan email configurado.",
        "Cada piloto recibirá su posición personal y la clasificación general.",
        "Los emails se envían desde clasificaciones@aecar.org"
      ]
    },
    {
      icon: FileSpreadsheet,
      title: "Formato de Archivos Excel",
      content: [
        "Plantilla de Pilotos (solo admin): licencia, nombre, apellidos, email, categoria",
        "Plantilla de Resultados: licencia, posicion",
        "La primera fila siempre son los títulos de columnas.",
        "La segunda fila muestra un ejemplo (puedes borrarlo).",
        "Guarda el archivo como .xlsx antes de subirlo."
      ]
    },
    {
      icon: UserCheck,
      title: "Gestión de Delegados (Admin)",
      content: [
        "Los nuevos delegados aparecen en 'Pendientes' tras registrarse.",
        "Revisa y aprueba/rechaza cada solicitud desde Administración.",
        "Puedes cambiar el rol de cualquier usuario (hacer admin o delegado).",
        "Puedes ver todos los usuarios registrados en 'Todos los usuarios'.",
        "Desde 'Base de Pilotos' subes el archivo Excel con todos los pilotos."
      ]
    },
    {
      icon: Image,
      title: "Personalización de Imágenes (Admin)",
      content: [
        "Desde Administración → Configuración puedes personalizar todas las imágenes.",
        "Logo principal: aparece en el menú lateral y emails.",
        "Fondo de la landing: imagen de fondo en la página de login.",
        "Fondo de la app: imagen de fondo para todo el dashboard.",
        "Imagen de emails: logo/imagen que aparece en los correos de clasificación."
      ]
    }
  ];

  return (
    <DashboardLayout>
      <div className="space-y-6" data-testid="manual-page">
        {/* Header */}
        <div className="flex items-center gap-3">
          <BookOpen className="w-8 h-8 text-primary" />
          <div>
            <h1 className="font-heading font-black text-2xl uppercase">
              Manual de Uso
            </h1>
            <p className="text-muted-foreground text-sm">
              Guía completa para gestionar tus campeonatos AECAR
            </p>
          </div>
        </div>

        {/* Quick Start */}
        <Card className="bg-primary/10 border-primary/30">
          <CardContent className="py-4">
            <div className="flex items-start gap-3">
              <HelpCircle className="w-5 h-5 text-primary mt-0.5" />
              <div>
                <h3 className="font-heading text-sm uppercase text-primary mb-1">
                  Inicio Rápido para Delegados
                </h3>
                <p className="text-sm text-muted-foreground">
                  1. Espera aprobación del admin → 2. Crea tu campeonato (con o sin asistencia) → 3. Sube resultados de cada carrera → ¡Clasificación automática!
                </p>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Sections */}
        <div className="grid gap-4 md:grid-cols-2">
          {sections.map((section, index) => (
            <Card 
              key={index} 
              className="bg-card/50 border-white/10"
              data-testid={`manual-section-${index}`}
            >
              <CardHeader className="pb-2">
                <CardTitle className="font-heading text-base uppercase flex items-center gap-2">
                  <section.icon className="w-5 h-5 text-primary" />
                  {section.title}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <ul className="space-y-2">
                  {section.content.map((item, i) => (
                    <li key={i} className="text-sm text-muted-foreground flex gap-2">
                      <span className="text-primary font-mono">{i + 1}.</span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Footer */}
        <Card className="bg-card/50 border-white/10">
          <CardContent className="py-4 text-center">
            <p className="text-sm text-muted-foreground">
              ¿Tienes dudas? Contacta con el administrador del sistema.
            </p>
            <p className="text-xs text-muted-foreground/60 mt-2">
              AECAR Championship Manager v2.0 - Sistema de gestión de campeonatos
            </p>
          </CardContent>
        </Card>
      </div>
    </DashboardLayout>
  );
}
